/**
 * Traduce los labels de un arreglo de campos utilizando una función de traducción i18n.
 *
 * Esta función utilitaria es independiente del contexto de Vue y recibe
 * explícitamente la función de traducción (`t`), lo que permite reutilizarla
 * en distintos componentes sin depender de `this`.
 *
 * La clave de traducción se construye con el siguiente patrón:
 * `${basePath}.${field.key}`
 *
 * @param fields - Arreglo de campos que deben contener la propiedad `key`.
 * @param basePath - Ruta base de i18n donde se encuentran las traducciones
 * de los labels de los campos.
 * @param t - Función de traducción i18n (por ejemplo, `$t` o `t` de vue-i18n),
 * la cual debe estar previamente ligada a su contexto correspondiente.
 *
 * @returns Un nuevo arreglo de campos con la propiedad `label` traducida.
 *
 * @example
 * ```ts
 * const fields = [{ key: 'nombre' }, { key: 'fechaInicio' }];
 *
 * const translatedFields = this.translateFields(
 *   fields,
 *   'miApp.modulo.tabla.fields'
 *   this.$t.bind(this)
 * );
 * ```
 */
export function translateFields(fields: Array<{ key: string }>, basePath: string, t: (key: string) => any) {
  return fields.map(f => ({
    ...f,
    label: t(`${basePath}.${f.key}`),
  }));
}
